import { makeStyles } from "@mui/styles";
import { ReactComponent as Info } from "../../../assets/icons-svg/info-circle.svg";
import { toRem16 } from "../../../scss/utils/styles";
import { UiText } from "./UiText";

const useStyles = makeStyles(() => {
    return {
        formContainer: {
            width: "100%",
            display: "flex",
            gap: toRem16(12),
            alignItems: "center",
            padding: `${toRem16(8)} ${toRem16(16)}`,
            borderRadius: toRem16(1),
            background: "rgba(23, 118, 182, 0.12)",
            marginBottom: toRem16(16),
        },
    };
});

const InfoBlock = ({ infoText }: { infoText: string }) => {
    const classes = useStyles();
    return (
        <div className={classes.formContainer}>
            <Info />
            <UiText>{infoText}</UiText>
        </div>
    );
};

export default InfoBlock;
